export const defaultLevelConfig = {
  spawnRadius: 1.5,
  playerRadius: 0.5,
  tileRadius: 0.5,
  minAttractorRadius: 1,
  maxAttractorRadius: 10,
  attractorStrength: 30,
  lineRadius: 0.5,
  maxAmountLines: 1000,
  maxAmountAttractors: 100,
  maxAmountPlayers: 100,
  maxAmountShards: 10,
  maxShardRadius: 10.5,
  minShardRadius: 1.5,
};
